export default __webpack_public_path__ + "assets/unification.bdf79788.svg";